document.addEventListener('DOMContentLoaded', () => {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

	window.addEventListener('resize', () => {
		vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});

	// var scrollbar = Scrollbar.init(document.querySelector("#wrapper"), {
	// 	damping: 0.1
	// });
	// ScrollTrigger.scrollerProxy(document.querySelector("#wrapper"), {
	// 	scrollTop: function scrollTop(value) {
	// 		if (arguments.length) {
	// 			scrollbar.scrollTop = value;
	// 		}
	// 		return scrollbar.scrollTop;
	// 	}
	// });
	// scrollbar.addListener(ScrollTrigger.update);
	// ScrollTrigger.addEventListener("refresh", function () {
	// 	return scrollbar.update();
	// });
	// ScrollTrigger.defaults({
	// 	scroller: document.querySelector("#wrapper")
	// });
	// ScrollTrigger.refresh();

	gsap.registerPlugin(ScrollTrigger);
	
	const fades = document.querySelectorAll('.fade');
	const inputs = document.querySelectorAll('.contact__form .input__set');
	let elements = [...fades, ...inputs];
	elements.forEach((fade) => {
		
		gsap
			.timeline({
				scrollTrigger: {
					trigger: fade,
					//   start: "top 80%",
					//   end: "bottom bottom",
				},
			})
			.from(fade, {
				ease: 'ease',
				autoAlpha: 0,
				y: 100,
				duration: 1,
			});
	});

	const navToggleButton = document.querySelector('.header__navToggle');
	const mobileNav = document.querySelector('.mobileNav');

	navToggleButton.addEventListener('click', () => {
		navToggleButton.classList.toggle('header__navToggle--open');
		mobileNav.classList.toggle('mobileNav--open');
	});

	// if (document.querySelector('.hero')) {
	// 	const heroSlider = new Swiper('.swiper.hero__slider', {
	// 		effect: 'fade',
	// 		autoplay: {
	// 			delay: 5000,
	// 		},
	// 		pagination: {
	// 			el: '.hero__slider .swiper-pagination',
	// 			type: 'fraction',
	// 		},
	// 	});
	// }
	if (document.querySelector('.aspects__slider--aspects')) {
		const aspectsSlider1 = new Swiper('.swiper.aspects__slider--aspects', {
			loop: 1,
			slidesPerView: 1,  autoHeight: true, 
			navigation: {
				nextEl:
					'.aspects__slider--aspects + .swiper-navigation .aspects__slider__next',
				prevEl:
					'.aspects__slider--aspects + .swiper-navigation .aspects__slider__prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
			},
		});
	}
	if (document.querySelector('.aspects__slider--recomendations')) {
		const aspectsSlider2 = new Swiper('.swiper.aspects__slider--recomendations', {
			loop: 1,
			slidesPerView: 1,  autoHeight: true, 
			navigation: {
				nextEl:
					'.aspects__slider--recomendations + .swiper-navigation .aspects__slider__next',
				prevEl:
					'.aspects__slider--recomendations + .swiper-navigation .aspects__slider__prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
			},
		});
	}
	if (document.querySelector('.recomendationsBlock__slider--recomendations')) {
		const aspectsSlider6 = new Swiper('.swiper.recomendationsBlock__slider--recomendations', {
			loop: 1,
			slidesPerView: 1,  autoHeight: true, 
			navigation: {
				nextEl:
					'.recomendationsBlock__slider--recomendations + .swiper-navigation .aspects__slider__next',
				prevEl:
					'.recomendationsBlock__slider--recomendations + .swiper-navigation .aspects__slider__prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
			},
		});
	}
	if (document.querySelector('.aspects__slider--opinions')) {
		const aspectsSlider3 = new Swiper('.swiper.aspects__slider--opinions', {
			loop: 1,
			slidesPerView: 1,
			navigation: {
				nextEl:
					'.aspects__slider--opinions + .swiper-navigation .aspects__slider__next',
				prevEl:
					'.aspects__slider--opinions + .swiper-navigation .aspects__slider__prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
			},
		});
	}
	if (document.querySelector('.sellings')) {
		const sellingsSlider = new Swiper('.swiper.sellings__slider', {
			loop: 1,
			slidesPerView: 1,
			navigation: {
				nextEl: '.sellings__slider__next',
				prevEl: '.sellings__slider__prev',
			},
		});
	}

	const c = document.querySelector('.header');
	window.addEventListener('scroll', () => {
		document.body.scrollTop > 60 || document.documentElement.scrollTop > 60
			? c.classList.add('header--scrolled')
			: c.classList.remove('header--scrolled');
	});
});
